import { CARTEIRAS_CHANGED, CARTEIRA_SELECTED } from "../../const/actionsType";

import { dates } from "investira.sdk";

const INITIAL_STATE = {
  data: [],
  current: {},
  updatedAt: dates.toDate(),
};

const RESET_STATE = {
  ...INITIAL_STATE,
};

function carteirasReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CARTEIRAS_CHANGED:
      return {
        ...state,
        data: action.payload,
        updatedAt: dates.toDate(),
      };
    case CARTEIRA_SELECTED:
      return {
        ...state,
        current: action.payload,
      };
    default:
      return state;
  }
}

export default carteirasReducer;
